import { render, staticRenderFns } from "./AutomationActionTeamMessageInput.vue?vue&type=template&id=3c870b84&scoped=true&"
import script from "./AutomationActionTeamMessageInput.vue?vue&type=script&lang=js&"
export * from "./AutomationActionTeamMessageInput.vue?vue&type=script&lang=js&"
import style0 from "./AutomationActionTeamMessageInput.vue?vue&type=style&index=0&id=3c870b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c870b84",
  null
  
)

export default component.exports